import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { FlatList, FlatListProps } from 'react-native';

export interface AssetsListProps<T> {
  id: string;
  data: T[];
  rows: number;
  columns: number;
  renderItem: FlatListProps<T>['renderItem'];
  keyExtractor: FlatListProps<T>['keyExtractor'];
}

export const AssetsList = <T,>({
  id,
  columns,
  rows,
  data,
  renderItem,
  keyExtractor,
}: AssetsListProps<T>) => {
  return (
    <FlatList
      key={id}
      style={{ overflow: 'visible' }}
      columnWrapperStyle={{
        justifyContent: rows === 1 ? 'space-between' : undefined,
        paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
      }}
      keyExtractor={keyExtractor}
      data={data}
      renderItem={renderItem}
      numColumns={columns}
    />
  );
};
